export default __webpack_public_path__ + "static/media/refresh.724ab853.svg";